import { render, staticRenderFns } from "./GroupOrderBlock.vue?vue&type=template&id=fe139d0e&lang=pug&"
import script from "./GroupOrderBlock.vue?vue&type=script&lang=js&"
export * from "./GroupOrderBlock.vue?vue&type=script&lang=js&"
import style0 from "./GroupOrderBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports